import { InjectionToken } from '@angular/core';

export const SHARED_LIB_CONFIG = new InjectionToken(
  'SHARED_LIB_CONFIG'
);
